// ========================= IMPORTS =========================
import Get from "./axios/get"
import Put from "./axios/put"
import Post from "./axios/post"

import {
  farms_backend,
  fuel_service,
  OsTicket,
  whatsappServices,
  booking_driver,
  capex_service_endpoint,
  approval_service_endpoint,
  travel_service_endpoint,
  ppe_service_endpoint,
  bidding_endpoint,
  epicor_service_endpoint,
  service_request_endpoint,
  dastr_endpoint,
  pa_service_endpoint,
  sap_endpoint,
} from "../config/api.config"

const buildQueryString = (params = {}) => {
  const query = new URLSearchParams()

  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === "" || value === false) {
      return
    }

    if (Array.isArray(value)) {
      value.forEach(val => {
        if (val !== undefined && val !== null && val !== "") {
          query.append(`${key}[]`, val)
        }
      })
      return
    }

    query.append(key, value)
  })

  const queryString = query.toString()
  return queryString ? `?${queryString}` : ""
}

// ========================= OS TICKET =========================
const CreateTicket = (header, data) => Post(`${OsTicket}/api/http.php/tickets.json`, header, data)

const ReplyFromUser = (header, data) => Post(`${OsTicket}/api/http.php/tickets/reply-user.json`, header, data)

const DetailTicket = (header, email) => Get(`${OsTicket}/api/http.php/tickets/clientTickets?clientUserMail=${email}`, header)

const TicketInfo = (header, id) => Get(`${OsTicket}/api/http.php/tickets/ticketInfo?ticketNumber=${id}`, header)

const getTopics = header => Get(`${OsTicket}/api/http.php/tickets/getTopics`, header)

// ========================= EPICOR =========================
const LoginEpicor = (header, data) => Post(`${epicor_service_endpoint.endpoint}/api/login`, header, data)

const GetEpicorPending = (header, data) => Get(`${epicor_service_endpoint.endpoint}/api/pending/${data}`, header)

const GetEpicorViewPO = (header, data) => Get(`${epicor_service_endpoint.endpoint}/api/po/${data}`, header)

const GetEpicorViewPR = (header, data) => Get(`${epicor_service_endpoint.endpoint}/api/pr/${data}`, header)

const GetEpicorViewIR = (header, data) => Get(`${epicor_service_endpoint.endpoint}/api/ir/${data}`, header)

const EpicorApproveIR = (header, id, data) => Put(`${epicor_service_endpoint.endpoint}/api/ir/${id}/approve`, header, data)

const EpicorRejectIR = (header, id, data) => Put(`${epicor_service_endpoint.endpoint}/api/ir/${id}/reject`, header, data)

const EpicorApprovePR = (header, id, data) => Put(`${epicor_service_endpoint.endpoint}/api/pr/${id}/approve`, header, data)

const EpicorRejectPR = (header, id, data) => Put(`${epicor_service_endpoint.endpoint}/api/pr/${id}/reject`, header, data)

const EpicorApprovePO = (header, id, data) => Put(`${epicor_service_endpoint.endpoint}/api/po/${id}/approve`, header, data)

const EpicorRejectPO = (header, id, data) => Put(`${epicor_service_endpoint.endpoint}/api/po/${id}/reject`, header, data)

// ========================= APPROVAL SYSTEM =========================

const getSessionSignin = (header, data) => Post(`${approval_service_endpoint.endpoint}/api/signin`, header, data)

const postComment = (header, data) => Post(`${approval_service_endpoint.endpoint}/api/comment`, header, data)

const ApprovalCancel = (header, data) => Post(`${approval_service_endpoint.endpoint}/api/cancel`, header, data)

const ApprovalReject = (header, data) => Post(`${approval_service_endpoint.endpoint}/api/reject`, header, data)

const ApprovalApproved = (header, data) => Post(`${approval_service_endpoint.endpoint}/api/approved`, header, data)

const ApprovalGetEmployeeDetail = (header, data) => Get(`${approval_service_endpoint.endpoint}/api/user/employeeid/${data}`, header)

const UserBranchID = (header, data) => Get(`${approval_service_endpoint.endpoint}/api/user/branchid/${data}`, header)

const menuLog = (header, data) => Post(`${approval_service_endpoint.endpoint}/api/menulog`, header, data)

const MyRequests = (header, { today, lastWeek }) => {
  const params = new URLSearchParams({ today, lastWeek })
  return Get(`${approval_service_endpoint.endpoint}/api/myrequests?${params.toString()}`, header)
}

const getOutStanding = (header, data) => Get(`${approval_service_endpoint.endpoint}/api/user/outstanding/${data}`, header)

const getMasterUsers = (header, params = {}) => Get(`${approval_service_endpoint.endpoint}/api/master-user${buildQueryString(params)}`, header)

const getCompaniesApproval = (header, params = {}) => Get(`${approval_service_endpoint.endpoint}/api/company${buildQueryString(params)}`, header)

const getDepartmentsApproval = (header, params = {}) => Get(`${approval_service_endpoint.endpoint}/api/department${buildQueryString(params)}`, header)

const getDepartmentsByCompanyApproval = (header, companyId) => Get(`${approval_service_endpoint.endpoint}/api/department/company/${companyId}`, header)

const getUserLevelsApproval = (header, params = {}) => Get(`${approval_service_endpoint.endpoint}/api/level-user${buildQueryString(params)}`, header)

const getRolesApproval = (header, params = {}) => Get(`${approval_service_endpoint.endpoint}/api/role${buildQueryString(params)}`, header)

// ========================= CAPEX =========================
const CreateCapex = (header, data) => Post(`${capex_service_endpoint.endpoint}/api/`, header, data)

const UsersBranchCapex = header => Get(`${capex_service_endpoint.endpoint}/api/usersbranch`, header)

const HistoryCapex = header => Get(`${capex_service_endpoint.endpoint}/api/history`, header)

const ViewCapex = (header, data) => Get(`${capex_service_endpoint.endpoint}/api/${data}`, header)

const EditCapex = (header, data) => Put(`${capex_service_endpoint.endpoint}/api/`, header, data)

const DepartementCapex = header => Get(`${capex_service_endpoint.endpoint}/api/ep/departments`, header)

const AssetGroupCapex = header => Get(`${capex_service_endpoint.endpoint}/api/ep/assetGroup`, header)

const ActivityCapex = header => Get(`${capex_service_endpoint.endpoint}/api/ep/activity`, header)

const ProjectsCapex = header => Get(`${capex_service_endpoint.endpoint}/api/ep/projects`, header)

const VendorCapex = header => Get(`${capex_service_endpoint.endpoint}/api/ep/vendor`, header)

const AssetCapex = header => Get(`${capex_service_endpoint.endpoint}/api/ep/assets`, header)

const AreaCapex = header => Get(`${capex_service_endpoint.endpoint}/api/ep/area`, header)

// ========================= BIDDING =========================
const CreateBidding = (header, data) => Post(`${bidding_endpoint.endpoint}/api/create`, header, data)

const AddComment = (header, data) => Post(`${bidding_endpoint.endpoint}/api/addcomment`, header, data)

const BiddingHistory = header => Get(`${bidding_endpoint.endpoint}/api/history`, header)

const BiddingDetail = (header, data) => Get(`${bidding_endpoint.endpoint}/api/detail?id=${data}`, header)

// ====================SAP BIDDING =========================
const sapCreateBidding = (header, data) => Post(`${sap_endpoint.endpoint}/api/v1/bidding`, header, data)

const sapGetListBiddingByBuyerID = (header, data) => Get(`${sap_endpoint.endpoint}/api/v1/bidding/history?buyerid=${data}`, header)

const getBidding = (header, data) => Get(`${sap_endpoint.endpoint}/api/v1/bidding/${data}`, header)

const sapAddCommentBidding = (header, data) => Post(`${sap_endpoint.endpoint}/api/v1/bidding/postcomment`, header, data)

// ========================= WHATSAPP =========================
const sendPersonalWa = data => Post(`${whatsappServices.waendpoint}/api/wa/pc`, whatsappServices.api_key, data)

const sendGroupWa = data => Post(`${whatsappServices.waendpoint}/api/wa/gr`, whatsappServices.api_key, data)

// ========================= FUEL SERVICE =========================
const HistoryRequestFuel = (header, data) => {
  const params = new URLSearchParams({ startDate: data.startDate, endDate: data.endDate })
  if (data.page) params.append("page", data.page)
  if (data.limit) params.append("limit", data.limit)
  if (data.fuel_truck) params.append("fuel_truck", data.fuel_truck)
  if (data.shift) params.append("shift", data.shift)
  if (data.hull_number) params.append("hull_number", data.hull_number)
  if (data.fuel_type) params.append("fuel_type", data.fuel_type)
  return Get(`${fuel_service.endpoint}/api/requests?${params.toString()}`, header, data)
}

const CreateRequestFuel = (header, data) => Post(`${fuel_service.endpoint}/api/request`, header, data, 600000)

const AdjustmentRequestFuel = (header, data) => Post(`${fuel_service.endpoint}/api/adjustment`, header, data)

const ViewRequestFuel = (header, data) => Get(`${fuel_service.endpoint}/api/request/${data}`, header)

const HistoryRequestDelivery = (header, data) => {
  const params = new URLSearchParams({ startDate: data.startDate, endDate: data.endDate })
  if (data.page) params.append("page", data.page)
  if (data.limit) params.append("limit", data.limit)
  if (data.fuel_truck) params.append("fuel_truck", data.fuel_truck)
  if (data.shift) params.append("shift", data.shift)
  if (data.fuel_type_delivery) params.append("fuel_type_delivery", data.fuel_type_delivery)
  return Get(`${fuel_service.endpoint}/api/delivery?${params.toString()}`, header, data)
}

const CalculateIssuedPeriod = (header, data) => {
  const params = new URLSearchParams()
  if (data.receiveID) {
    params.append("receiveID", data.receiveID)
  }
  data.datePeriod?.forEach(date => params.append("datePeriod[]", date))
  const queryString = params.toString()
  return Get(`${fuel_service.endpoint}/api/delivery/calculateIssued?${queryString}`, header)
}

const ViewDeliveryRequestFuel = (header, data) => Get(`${fuel_service.endpoint}/api/delivery/${data}`, header)

const CreateRequestDelivery = (header, data) => Post(`${fuel_service.endpoint}/api/delivery`, header, data, 600000)

const AdjustmentDeliveryRequestFuel = (header, data) => Post(`${fuel_service.endpoint}/api/delivery/adjustment`, header, data)

const Organization = (header, data) => Get(`${fuel_service.endpoint}/api/request/organization`, header, data)

const Equipments = (header, data) => Get(`${fuel_service.endpoint}/api/equipment`, header, data)

const CreateOperator = (header, data) => Post(`${fuel_service.endpoint}/api/operator/register`, header, data)

const Operators = (header, data) => Get(`${fuel_service.endpoint}/api/operator`, header, data)

const ResetPasswordOperator = (header, data) => Post(`${fuel_service.endpoint}/api/operator/reset`, header, data)

const JobLocation = (header, data) => Get(`${fuel_service.endpoint}/api/job-locations`, header, data)

const EquipmentActivity = (header, data) => Get(`${fuel_service.endpoint}/api/equipment-activities`, header, data)

const StorageTank = (header, data) => Get(`${fuel_service.endpoint}/api/storage-tanks`, header, data)

const TankerVehicle = (header, data) => Get(`${fuel_service.endpoint}/api/tanker-vehicles`, header, data)

// ========================= FORECAST =========================
const FmsGetForcastToday = (header, timezone) => Get(`https://forcast.fms.api.brmapps.com/predict_today?timezone=${timezone}`, header)

const FmsGetForcast = (header, timezone) => Get(`https://forcast.fms.api.brmapps.com/forecast?timezone=${timezone}`, header)

// ========================= TIMESHEET =========================
const historyTimeSheet = (header, data) => Get(`${farms_backend.endpoint}/api/access/ts/history?email=${data}`, header)

const createTimeSheet = (header, data) => Post(`${farms_backend.endpoint}/api/access/ts/create`, header, data)

const getUserCredential = (header, data) => Post(`${farms_backend.endpoint}/api/access/signin`, header, data)

const viewTS = (header, data) => Get(`${farms_backend.endpoint}/api/access/ts/view?_id=${data}`, header)

const PrintTSRange = (header, _) => Get(`${farms_backend.endpoint}/api/dashboard/printAll?dateFrom=2022-09-17&dateTo=2022-10-16`, header)

const getLastOutstanding = (header, data) => Get(`${farms_backend.endpoint}/api/access/ts/get-last-outstanding`, header, data)

const getListHoliday = (header, data) => Get(`${farms_backend.endpoint}/api/timesheet/get-holiday`, header, data)

// ========================= BILLING TELKOMSEL =========================
const ViewBillingTelkomsel = (header, data) => Get(`${farms_backend.endpoint}/api/access/biling/telkomsel/view?id=${data}`, header)

// ========================= SERVICE REQUEST =========================
const SRNewRequest = (header, data) => Post(`${service_request_endpoint.endpoint}/api/create`, header, data)

const getApplications = (header, _) => Get(`${service_request_endpoint.endpoint}/api/software`, header)

const SRHistory = (header, params = {}) => {
  const qs = new URLSearchParams({
    paginate: 1,
    page: params.page ?? 1,
    limit: params.limit ?? 10,
    ...(params.status ? { status: params.status } : {}),
  }).toString();
  return Get(`${service_request_endpoint.endpoint}/api/history?${qs}`, header);
}

const SROrganizations = (header, _) => Get(`${service_request_endpoint.endpoint}/api/organization`, header)

const SRRequestors = (header, params = {}) => {
  const qs = params?.refresh ? "?refresh=1" : "";
  return Get(`${service_request_endpoint.endpoint}/api/requestor${qs}`, header);
}

const SRView = (header, data) => Get(`${service_request_endpoint.endpoint}/api/view/${data}`, header)

const SRAccountList = (header) => Get(`${service_request_endpoint.endpoint}/api/account`, header)
const SRTypeRequestList = (header) => Get(`${service_request_endpoint.endpoint}/api/type-request`, header)
const SREquipmentList = (header) => Get(`${service_request_endpoint.endpoint}/api/equipment`, header)

const getUsersSR = (header, _) => Get(`${farms_backend.endpoint}/api/access/sr/users`, header)

// ========================= PPE REQUEST =========================
const CreatePPERequest = (header, data) => Post(`${ppe_service_endpoint.endpoint}/api/ppe-requests`, header, data)

const PPEHistory = header => Get(`${ppe_service_endpoint.endpoint}/api/ppe-requests/employee`, header)

const PPEView = (header, recordId) => Get(`${ppe_service_endpoint.endpoint}/api/ppe-requests/${recordId}`, header)

// PPE Masters + Employees
const PPEEmployeesByBranch = header => Get(`${ppe_service_endpoint.endpoint}/api/employees-by-branch`, header)

const PPEActivities = header => Get(`${ppe_service_endpoint.endpoint}/api/ppe-activity`, header)

const PPEHazardTypes = header => Get(`${ppe_service_endpoint.endpoint}/api/ppe-hazard-type`, header)

const PPEItems = header => Get(`${ppe_service_endpoint.endpoint}/api/ppe-item`, header)

const PPESizes = header => Get(`${ppe_service_endpoint.endpoint}/api/ppe-size`, header)

const PPEColors = header => Get(`${ppe_service_endpoint.endpoint}/api/ppe-color`, header)

const PPECategory = header => Get(`${ppe_service_endpoint.endpoint}/api/ppe-category`, header)

// ========================= TRAVEL AUTHORITY =========================
const newTravelAuthority = (header, data) => Post(`${travel_service_endpoint.endpoint}/api/travel`, header, data)

const editTravelAuthority = (header, recordId, data) => Put(`${travel_service_endpoint.endpoint}/api/travel/${recordId}`, header, data, 600000)

const HistoryTA = (header, params = {}) => {
  const qs = new URLSearchParams({
    paginate: 1,
    page: params.page ?? 1,
    limit: params.limit ?? 10,
    ...(params.status ? { status: params.status } : {}),
  }).toString();
  return Get(`${travel_service_endpoint.endpoint}/api/travel?${qs}`, header);
}

const viewTA = (header, data) => Get(`${travel_service_endpoint.endpoint}/api/travel/${data}`, header)

const getTravellers = header => Get(`${travel_service_endpoint.endpoint}/api/travel/travellers`, header)

const getNonEmployeeTA = (header, params) => {
  const p = params || {};
  const qs = new URLSearchParams();
  if (p.q) qs.set("q", p.q);
  if (p.page) qs.set("page", String(p.page));
  if (p.limit) qs.set("limit", String(p.limit));
  const query = qs.toString();
  const url = query
    ? `${travel_service_endpoint.endpoint}/api/travel/nonemployees?${query}`
    : `${travel_service_endpoint.endpoint}/api/travel/nonemployees`;
  return Get(url, header);
}

const getUsersTA = (header, _) => Get(`${farms_backend.endpoint}/api/access/sr/users`, header)

const getPicTA = (header, _) => Get(`${farms_backend.endpoint}/api/access/ta/pic`, header)

// ========================= HIAS =========================
const CreateHias = (header, data) => Post(`${farms_backend.endpoint}/api/access/hias`, header, data)

// ========================= WORKING PERMIT =========================
const getWorkingItems = (header, _) => Get(`${farms_backend.endpoint}/api/access/wp/items`, header)

const historyWorkingPermit = (header, data) => Get(`${farms_backend.endpoint}/api/access/wp/history?email=${data}&startDate=${data.startDate}&endDate=${data.endDate}`, header)

const historyWorkingPermitMonitor = (header, data) => Get(`${farms_backend.endpoint}/api/access/wp/history/monitor?startDate=${data.startDate}&endDate=${data.endDate}`, header)

const createWorkingPermit = (header, data) => Post(`${farms_backend.endpoint}/api/access/wp/create`, header, data)

const viewWorkingPermit = (header, data) => Get(`${farms_backend.endpoint}/api/access/wp/view?id_record=${data}`, header, data)

const WorkingWorkEnd = (header, data) => Post(`${farms_backend.endpoint}/api/access/wp/end`, header, data)

const WorkingWorkEdit = (header, data) => Post(`${farms_backend.endpoint}/api/access/wp/edit`, header, data)

const ResponsibleArea = (header, data) => Get(`${farms_backend.endpoint}/api/access/wp/responsible-area`, header, data)

// ========================= VALIDATION PERMIT =========================
const viewValidation = (header, data) => Get(`${farms_backend.endpoint}/api/access/vwp/view?id_record=${data}`, header, data)

const addNotesValidation = (header, data) => Post(`${farms_backend.endpoint}/api/access/vwp/notes`, header, data)

const createValidation = (header, data) => Post(`${farms_backend.endpoint}/api/access/vwp/create`, header, data)

// ========================= WORKFLOW =========================
const workflowApprovedDetails = (header, data) => Get(`${farms_backend.endpoint}/api/access/approval/approvedof?approval_key=${data}`, header, data)

const workflowPending = (header, params = {}) => Get(`${approval_service_endpoint.endpoint}/api/pending${buildQueryString(params)}`, header)

const workflowPendingCount = (header, params = {}) => Get(`${approval_service_endpoint.endpoint}/api/pending/count${buildQueryString(params)}`, header)

const workflowApproved = (header, data) => Post(`${farms_backend.endpoint}/api/access/approval/list/approve`, header, data)

const workflowReject = (header, data) => Post(`${farms_backend.endpoint}/api/access/approval/list/reject`, header, data)

const workflowCancel = (header, data) => Post(`${farms_backend.endpoint}/api/access/approval/list/cancel`, header, data)

// ========================= HCM / TALENTA =========================
const getUsers = (header, _) => Get(`${farms_backend.endpoint}/api/integration/hcm-recruitment/supervisor`, header)

const getDepartment = (header, _) => Get(`${farms_backend.endpoint}/api/integration/hcm-recruitment/departments`, header)

const getLevel = (header, _) => Get(`${farms_backend.endpoint}/api/integration/hcm-recruitment/level`, header)

const waVerification = (header, data) => Post(`${farms_backend.endpoint}/api/access/auth/verification`, header, data)

const completeUserData = (header, data) => Post(`${approval_service_endpoint.endpoint}/api/verification/completed-user`, header, data)

const Stock = (header, _) => Get(`${farms_backend.endpoint}/api/integration/stock`, header)

// ========================= BOOKING DRIVER =========================
const CreateBookingDriver = (header, data) => Post(`${booking_driver.endpoint}/api/request`, header, data)

const UpdateBookingDriver = (header, data) => Put(`${booking_driver.endpoint}/api/request`, header, data)

const ListBookingDriverByPlateNumber = (header, data) => Get(`${booking_driver.endpoint}/api/request?plate_number=${data}`, header)

const ListBookingDriverByPlateNumberAndDate = (header, plateNumber, date) => Get(`${booking_driver.endpoint}/api/request?plate_number=${plateNumber}&date=${date}`, header)

const ListBookingDriverByIdRecord = (header, data) => Get(`${booking_driver.endpoint}/api/request?id_record=${data}`, header)

const getJobPositionTalentaByid = header => Get(`${booking_driver.endpoint}/api/talenta/employee/job-position`, header)

const GetBookingDetail = (header, id_record) => Get(`${booking_driver.endpoint}/api/request/${id_record}`, header)

const ListCar = header => Get(`${booking_driver.endpoint}/api/car`, header)

const ListMyRequests = (header, employee_id, plate_number) => {
  const params = new URLSearchParams({ employee_id })
  if (plate_number) params.append("plate_number", plate_number)
  return Get(`${booking_driver.endpoint}/api/my-requests?${params.toString()}`, header)
}

// ========================= STATIC DATA =========================
const Cities = (header, _) => Get(`${farms_backend.endpoint}/api/integration/city`, header)

const Airports = (header, _) => Get(`${farms_backend.endpoint}/api/integration/airports`, header)

const Airlines = (header, _) => Get(`${farms_backend.endpoint}/api/integration/airlines`, header)

const getEmployeeTalentaByEmployeeId = (header, data) => {
  const params = new URLSearchParams()

  if (data !== undefined && data !== null && data !== "") {
    params.append("employee_id", data)
  }

  const query = params.toString()

  return Get(`${farms_backend.endpoint}/api/talenta/employee${query ? `?${query}` : ""}`, header)
}

const getEmployeeTalentaByBranch = (header, data) => Get(`${farms_backend.endpoint}/api/talenta/employee/branch?branch_id=${data}`, header)

const getEmployeeTalentaByid = (header, data) => Get(`${farms_backend.endpoint}/api/talenta/employee/detail?id=${data}`, header)

// ========================= BOOKING =========================
const CreateBooking = (header, data) => Post(`${booking_driver.endpoint}/api/booking`, header, data)

const ListBooking = (header, _) => Get(`${booking_driver.endpoint}/api/booking`, header)

const DetailBooking = (header, id) => Get(`${booking_driver.endpoint}/api/booking/${id}`, header)

// ========================= STATIC DATA =========================
const StaticData = (header, data) => Get(`${farms_backend.endpoint}/api/access/static-data`, header, data)

// ========================= DASTR =========================
const createDocument = (header, data) => Post(`${dastr_endpoint.endpoint}/api/documents`, header, data)

const getDocumentsByEmployeeId = header => Get(`${dastr_endpoint.endpoint}/api/documents/employee`, header)

const getDocumentByRecordId = (header, recordId) => Get(`${dastr_endpoint.endpoint}/api/documents/record/${recordId}`, header)

const getEmployeesByBranch = header => Get(`${dastr_endpoint.endpoint}/api/employees-by-branch`, header)

// ========================= Performance Appraisal =========================
const ListPAMasterPerformance = (header, params = {}) => {
  const query = buildQueryString(params)
  return Get(`${pa_service_endpoint.endpoint}/api/pa/master/performance${query}`, header)
}

const ListPAMasterCompetencies = (header, params = {}) => {
  const query = buildQueryString(params)
  return Get(`${pa_service_endpoint.endpoint}/api/pa/master/competencies${query}`, header)
}

const ListPATransactionsMe = (header, params = {}) => {
  const query = buildQueryString(params)
  return Get(`${pa_service_endpoint.endpoint}/api/pa/records/me${query}`, header)
}

const GetPATransaction = (header, recordId) => Get(`${pa_service_endpoint.endpoint}/api/pa/records/${recordId}`, header)

const CreatePATransaction = (header, data) => Post(`${pa_service_endpoint.endpoint}/api/pa/records`, header, data, 600000)

const UpdatePATransaction = (header, recordId, data) => Put(`${pa_service_endpoint.endpoint}/api/pa/records/${recordId}`, header, data, 600000)

const UploadPATaskEvidence = (header, formData) => Post(`${pa_service_endpoint.endpoint}/api/pa/tasks/evidence`, header, formData, 600000)

// ========================= EXPORT API =========================
const API = {
  // Epicor
  LoginEpicor,
  GetEpicorPending,
  GetEpicorViewPR,
  GetEpicorViewPO,
  EpicorApprovePR,
  EpicorRejectPR,
  EpicorApprovePO,
  EpicorRejectPO,
  UserBranchID,
  GetEpicorViewIR,
  EpicorApproveIR,
  EpicorRejectIR,
  // Approval
  getSessionSignin,
  ApprovalCancel,
  ApprovalReject,
  ApprovalApproved,
  ApprovalGetEmployeeDetail,
  MyRequests,
  menuLog,
  getOutStanding,
  postComment,

  // OsTicket
  CreateTicket,
  ReplyFromUser,
  DetailTicket,
  TicketInfo,
  getTopics,

  // Capex
  CreateCapex,
  UsersBranchCapex,
  HistoryCapex,
  ViewCapex,
  EditCapex,
  DepartementCapex,
  AssetGroupCapex,
  ActivityCapex,
  ProjectsCapex,
  VendorCapex,
  AssetCapex,
  AreaCapex,

  // Bidding
  CreateBidding,
  BiddingHistory,
  BiddingDetail,
  AddComment,

  // WhatsApp
  sendPersonalWa,
  sendGroupWa,

  // Fuel
  HistoryRequestFuel,
  CreateRequestFuel,
  AdjustmentRequestFuel,
  ViewRequestFuel,
  HistoryRequestDelivery,
  CalculateIssuedPeriod,
  ViewDeliveryRequestFuel,
  CreateRequestDelivery,
  AdjustmentDeliveryRequestFuel,
  Organization,
  Equipments,
  CreateOperator,
  Operators,
  ResetPasswordOperator,
  JobLocation,
  EquipmentActivity,
  StorageTank,
  TankerVehicle,
  FmsGetForcast,
  FmsGetForcastToday,

  // Timesheet
  historyTimeSheet,
  createTimeSheet,
  getUserCredential,
  viewTS,
  PrintTSRange,
  getLastOutstanding,
  getListHoliday,

  // Billing
  ViewBillingTelkomsel,

  // Service Request
  SRNewRequest,
  SRRequestors,
  getApplications,
  SROrganizations,
  SRAccountList,
  SRTypeRequestList,
  SREquipmentList,
  getUsersSR,
  SRHistory,
  SRView,

  // Travel Authority
  newTravelAuthority,
  editTravelAuthority,
  HistoryTA,
  viewTA,
  getTravellers,
  getNonEmployeeTA,
  getUsersTA,
  getPicTA,

  // HIAS
  CreateHias,

  // Working Permit
  getWorkingItems,
  createWorkingPermit,
  historyWorkingPermit,
  historyWorkingPermitMonitor,
  viewWorkingPermit,
  WorkingWorkEnd,
  WorkingWorkEdit,
  ResponsibleArea,

  // Validation Permit
  viewValidation,
  addNotesValidation,
  createValidation,

  // Workflow
  workflowApprovedDetails,
  workflowPending,
  workflowPendingCount,
  workflowApproved,
  workflowReject,
  workflowCancel,

  // HCM / Talenta
  getUsers,
  getDepartment,
  getLevel,
  waVerification,
  completeUserData,
  getMasterUsers,
  getCompaniesApproval,
  getDepartmentsApproval,
  getDepartmentsByCompanyApproval,
  getUserLevelsApproval,
  getRolesApproval,
  Stock,
  getEmployeeTalentaByEmployeeId,
  getEmployeeTalentaByBranch,
  getEmployeeTalentaByid,

  // Booking Driver
  CreateBookingDriver,
  UpdateBookingDriver,
  ListBookingDriverByPlateNumber,
  ListBookingDriverByPlateNumberAndDate,
  ListBookingDriverByIdRecord,
  GetBookingDetail,
  getJobPositionTalentaByid,
  ListCar,
  ListMyRequests,

  // Booking
  CreateBooking,
  ListBooking,
  DetailBooking,

  // Static
  Cities,
  Airports,
  Airlines,
  StaticData,

  // Performance Appraisal
  ListPAMasterPerformance,
  ListPAMasterCompetencies,
  ListPATransactionsMe,
  GetPATransaction,
  CreatePATransaction,
  UpdatePATransaction,
  UploadPATaskEvidence,

  // DASTR
  createDocument,
  getDocumentsByEmployeeId,
  getDocumentByRecordId,
  getEmployeesByBranch,

  // PPE Request
  CreatePPERequest,
  PPEHistory,
  PPEView,
  PPEEmployeesByBranch,
  PPEActivities,
  PPEHazardTypes,
  PPEItems,
  PPESizes,
  PPEColors,
  PPECategory,

  // SAPBidding
  sapCreateBidding,
  sapGetListBiddingByBuyerID,
  getBidding,
  sapAddCommentBidding,
}

export default API
